export const gradientTextLeftToRightStyles = {
  backgroundImage: "linear-gradient(90deg, #5442b9, white, #5442b9)",
  backgroundSize: "200% auto",
  backgroundClip: "text",
  WebkitBackgroundClip: "text",
  color: "transparent",
  WebkitTextFillColor: "transparent",
  animation: "waveSlide 5s linear infinite",
};

export const backgroundGradientStyles = {
  backgroundImage: "linear-gradient(90deg, #5442b9, white, #5442b9)",
  animation: "waveSlide 5s linear infinite",
  backgroundSize: "200% auto",

};
